export enum SelectionType {
    None = 0,
    SingleSelect = 1,
    MultiSelect = 2,
    Text = 3,
    DropdownWithSingleSelect = 4,
    MultiSelectWithDropdown = 5,
    UtilityCompany = 6,
    DateTime = 7,
}
